import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@mui/material';
import { getDateDifference } from 'utils/dateFormater';
interface IModalCommon {
    handleClose?: () => void;
    notifications: any;
    handleClick: any;
    deleteNotification: any;
    noteTab: string;
    setNoteTab: any;
}
const NotificationModal: React.FC<IModalCommon> = ({ handleClose, notifications, handleClick, deleteNotification, noteTab, setNoteTab }) => {
  const handleTabSwitch = (newTab: string) => {
    switch (newTab) {
    case 'All':
      setNoteTab('All');
      window.sessionStorage.setItem('noteTab', 'All');
      break;
    case 'User':
      setNoteTab('User');
      window.sessionStorage.setItem('noteTab', 'User');
      break;
    case 'System':
      setNoteTab('System');
      window.sessionStorage.setItem('noteTab', 'System');
      break;
    case 'Starred':
      setNoteTab('Starred');
      window.sessionStorage.setItem('noteTab', 'Starred');
      break;
    default:
      setNoteTab('All');
    }
  };

  return (
    <div className='notification-modal'>
      <div className='notification-modal-header'>
        <div className='notification-modal-header-cont'>
          <div className='notification-modal-header-cont-text'>
            Notifications
          </div>
          <div className='notification-modal-header-cont-btn' onClick={handleClose}>
            <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
              <path d='M18 6L6 18M6 6L18 18' stroke='#BDBEC1' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
            </svg>
          </div>
        </div>
        <div className='screening-tabs-container' style={{ padding: '0px 24px' }}>
          <div className='screening-tabs-inner'>
            <div
              className={`screening-tab-btn${
                noteTab === 'All' ? '-selected' : ''
              }`}
              onClick={() => handleTabSwitch('All')}
            >
              <div
                className={`screening-tab-btn-text${
                  noteTab === 'All' ? '-selected' : ''
                }`}
              >
              All
              </div>
            </div>
            <div
              className={`screening-tab-btn${
                noteTab === 'User' ? '-selected' : ''
              }`}
              onClick={() => handleTabSwitch('User')}
            >
              <div
                className={`screening-tab-btn-text${
                  noteTab === 'User' ? '-selected' : ''
                }`}
              >
              User
              </div>
            </div>
            <div
              className={`screening-tab-btn${
                noteTab === 'System' ? '-selected' : ''
              }`}
              onClick={() => handleTabSwitch('System')}
            >
              <div
                className={`screening-tab-btn-text${
                  noteTab === 'System' ? '-selected' : ''
                }`}
              >
              System
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='notification-modal-body'>
        { notifications.length > 0 ? (
          <div className='notification-modal-body-cont'>
            {notifications.map((note: any, i: number) =>
              <div className='notification-modal-body-cont-card' onClick={() => handleClick(note)} key={i}>
                <div className='notification-modal-body-cont-card-cont'>
                  <div className='notification-modal-body-cont-card-cont-sec'>
                    <div className='notification-modal-body-cont-card-cont-sec-heading'>
                      {note.heading}
                      <div style={{ cursor: 'pointer' }} onClick={() => deleteNotification(note._id)}>
                        <svg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18' fill='none'>
                          <path d='M7.5 13.5C7.69891 13.5 7.88968 13.421 8.03033 13.2803C8.17098 13.1397 8.25 12.9489 8.25 12.75V8.25C8.25 8.05109 8.17098 7.86032 8.03033 7.71967C7.88968 7.57902 7.69891 7.5 7.5 7.5C7.30109 7.5 7.11032 7.57902 6.96967 7.71967C6.82902 7.86032 6.75 8.05109 6.75 8.25V12.75C6.75 12.9489 6.82902 13.1397 6.96967 13.2803C7.11032 13.421 7.30109 13.5 7.5 13.5ZM15 4.5H12V3.75C12 3.15326 11.7629 2.58097 11.341 2.15901C10.919 1.73705 10.3467 1.5 9.75 1.5H8.25C7.65326 1.5 7.08097 1.73705 6.65901 2.15901C6.23705 2.58097 6 3.15326 6 3.75V4.5H3C2.80109 4.5 2.61032 4.57902 2.46967 4.71967C2.32902 4.86032 2.25 5.05109 2.25 5.25C2.25 5.44891 2.32902 5.63968 2.46967 5.78033C2.61032 5.92098 2.80109 6 3 6H3.75V14.25C3.75 14.8467 3.98705 15.419 4.40901 15.841C4.83097 16.2629 5.40326 16.5 6 16.5H12C12.5967 16.5 13.169 16.2629 13.591 15.841C14.0129 15.419 14.25 14.8467 14.25 14.25V6H15C15.1989 6 15.3897 5.92098 15.5303 5.78033C15.671 5.63968 15.75 5.44891 15.75 5.25C15.75 5.05109 15.671 4.86032 15.5303 4.71967C15.3897 4.57902 15.1989 4.5 15 4.5ZM7.5 3.75C7.5 3.55109 7.57902 3.36032 7.71967 3.21967C7.86032 3.07902 8.05109 3 8.25 3H9.75C9.94891 3 10.1397 3.07902 10.2803 3.21967C10.421 3.36032 10.5 3.55109 10.5 3.75V4.5H7.5V3.75ZM12.75 14.25C12.75 14.4489 12.671 14.6397 12.5303 14.7803C12.3897 14.921 12.1989 15 12 15H6C5.80109 15 5.61032 14.921 5.46967 14.7803C5.32902 14.6397 5.25 14.4489 5.25 14.25V6H12.75V14.25ZM10.5 13.5C10.6989 13.5 10.8897 13.421 11.0303 13.2803C11.171 13.1397 11.25 12.9489 11.25 12.75V8.25C11.25 8.05109 11.171 7.86032 11.0303 7.71967C10.8897 7.57902 10.6989 7.5 10.5 7.5C10.3011 7.5 10.1103 7.57902 9.96967 7.71967C9.82902 7.86032 9.75 8.05109 9.75 8.25V12.75C9.75 12.9489 9.82902 13.1397 9.96967 13.2803C10.1103 13.421 10.3011 13.5 10.5 13.5Z' fill='#BDBEC1'/>
                        </svg>
                      </div>
                    </div>
                    <div className='notification-modal-body-cont-card-cont-sec-paragraph'>
                      {note.message}
                    </div>
                    {note.link || note.type === 'ticket' ? (
                      <div className='note-btn-container'>
                        <Link to={note.link}>
                          <Button className='note-link-btn' onClick={handleClose}>{note.type === 'invite' ? 'View Invite' : 'View Ticket'}</Button>
                        </Link>
                      </div>
                    ) : (
                      <></>
                    )}
                    <div className='notification-modal-body-cont-card-cont-sec-timer'>
                      {getDateDifference(note.createdAt)}
                    </div>
                  </div>
                </div>
                {note.status === 'unread' && <div className='notification-modal-body-cont-card-icon'>
                  <svg xmlns='http://www.w3.org/2000/svg' width='10' height='10' viewBox='0 0 10 10' fill='none'>
                    <circle cx='5' cy='5' r='4' fill='#F79009'/>
                  </svg>
                </div>}
              </div>
            )}
          </div>
        ) : (
          <div className='notification-modal-body-cont'>
            <div className='note-modal-no-note-div'>
                          No Notifications
            </div>
          </div>
        )}
      </div>
      <div className='notification-modal-footer'>
      </div>
    </div>
  );
};

export default NotificationModal;
